import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["input", "card", "clearButton", "resultCount", "hubFilter", "programFilter", "tagFilter"]

  connect() {
    this.totalCards = this.cardTargets.length
    this.updateResultCount(this.totalCards)
  }

  filterByHub(event) {
    // Submit the form to reload the page with the selected hub
    event.target.form.requestSubmit()
  }

  // Card #4388: Program filter, same pattern as filterByHub above.
  filterByProgram(event) {
    // Submit the form to reload the page with the selected program
    event.target.form.requestSubmit()
  }

  search(event) {
    const query = event.target.value.trim()

    // Show/hide clear button
    if (this.hasClearButtonTarget) {
      this.clearButtonTarget.style.display = query ? '' : 'none'
    }

    this.applyFilters()
  }

  filterByTag() {
    this.applyFilters()
  }

  clear() {
    this.inputTarget.value = ''
    if (this.hasTagFilterTarget) {
      // Reset native select
      Array.from(this.tagFilterTarget.options).forEach(opt => opt.selected = false)
      // Reset slim-select UI if present
      const slimCtrl = this.application.getControllerForElementAndIdentifier(this.tagFilterTarget, 'slim')
      if (slimCtrl && slimCtrl.select) {
        slimCtrl.select.setSelected([])
      }
    }
    this.showAllCards()
    if (this.hasClearButtonTarget) {
      this.clearButtonTarget.style.display = 'none'
    }
    this.inputTarget.focus()
  }

  applyFilters() {
    const query = this.inputTarget.value.trim().toLowerCase()
    const selectedTags = this.hasTagFilterTarget
      ? Array.from(this.tagFilterTarget.selectedOptions).map(o => o.value).filter(v => v)
      : []
    const searchWords = query ? query.split(/\s+/) : []

    let visibleCount = 0

    this.cardTargets.forEach(card => {
      let matchesSearch = true
      let matchesTag = true

      if (searchWords.length > 0) {
        const searchableText = card.dataset.searchableText
        matchesSearch = searchWords.some(word => searchableText.includes(word))
      }

      if (selectedTags.length > 0) {
        const cardTags = (card.dataset.tagNames || '').split(',').filter(t => t)
        matchesTag = selectedTags.some(tag => cardTags.includes(tag))
      }

      if (matchesSearch && matchesTag) {
        card.style.display = ''
        visibleCount++
      } else {
        card.style.display = 'none'
      }
    })

    this.updateResultCount(visibleCount)
    this.hideEmptyProjectGroups()
  }

  showAllCards() {
    this.cardTargets.forEach(card => card.style.display = '')
    this.showAllProjectGroups()
    this.updateResultCount(this.totalCards)
  }

  hideEmptyProjectGroups() {
    // Hide project groups that have no visible cards
    document.querySelectorAll('[data-project-group]').forEach(group => {
      const visibleCards = Array.from(
        group.querySelectorAll('[data-cards-search-target="card"]')
      ).some(card => card.style.display !== 'none')

      group.style.display = visibleCards ? '' : 'none'
    })
  }

  showAllProjectGroups() {
    document.querySelectorAll('[data-project-group]').forEach(group => {
      group.style.display = ''
    })
  }

  updateResultCount(count) {
    if (this.hasResultCountTarget) {
      this.resultCountTarget.textContent =
        count === this.totalCards
          ? `${count} cards`
          : `${count} of ${this.totalCards} cards`
    }
  }
}
